import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const InfoCircleSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return (
    <div {...props}>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7" cy="7" r="5.25" stroke="currentColor" strokeWidth="1.5" />
        <path d="M7 6.3V9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M7 4.5V4.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </div>
  )
}

export default InfoCircleSvg
